export default __webpack_public_path__ + "static/media/login-presentation.8bec878d.png";